import {
  MatSnackBarVerticalPosition,
  MatSnackBarHorizontalPosition
} from "@angular/material/snack-bar";


export declare type SnackBarHorizontalPosition =
  | "start"
  | "center"
  | "end"
  | "left"
  | "right";

export declare type SnackBarVerticalPosition = "top" | "bottom";

export declare type SnackBarMessageType = "error" | "success" | "warning";

export class GSPSnackBarData {
  constructor(public Message: string, public Title: string, public MessageType: SnackBarMessageType, public Parameters: any = null) { }
}
export class GspSnackbar {
  constructor(
    public MessageType: SnackBarMessageType,
    public IsSticky: boolean = true,
    public IsDismissable: boolean = true,
    public DisplayTime: number = 5000,
    public VerticalPosition: SnackBarVerticalPosition = "top",
    public HorizontalPosition: SnackBarHorizontalPosition = "center",

  ) { }
}